import type { ScrollingState } from './types';

export const hasStateChanged = (oldState: ScrollingState, newState: ScrollingState) =>
	(!oldState.isScrollingX && newState.isScrollingX) ||
	(!oldState.isScrollingY && newState.isScrollingY);
